"use client";

import { GenericListPage, type GenericListConfig } from "@admin/_components/generic-list-page";

const config: GenericListConfig = {
  title: "Additional Members",
  subtitle: "Manage additional members in your Perennial Mandalism subscription",
  listEndpoint: "user/perennial_mandalism_aditonal_member-details-fetch",
  countEndpoint: "user/perennial_mandalism_aditonal_member-details-fetch-count",
  deleteEndpoint: "user/remove_perennial_mandalism_member",
  addPath: "/admin/perennial/members/add",
  editPath: "/admin/perennial/members/edit",
  addButtonLabel: "+ Add Member",
  columns: [
    { key: "name", label: "Name", sortable: true },
    { key: "email", label: "Email" },
    { key: "phone", label: "Phone" },
    { key: "status", label: "Status", type: "status" },
    { key: "created_at", label: "Added", type: "date", sortable: true },
  ],
};

export default function PerennialMembersPage() {
  return <GenericListPage config={config} />;
}
